@if ((normalizedLink().groupedLinks?.length ?? 0) > 0) {
    <div class="flex size-full h-152 w-204 flex-col gap-y-8">
        <p class="line-clamp-1 typo-sm-bold-uppercase wrap-break-word">
            {{ normalizedLink().label }}
        </p>
        @for (subLink of normalizedLink().groupedLinks; track subLink.id) {
            @let subLinkLabel = subLink.label;
            @let subLinkInternalHref = subLink | apply: subLinkHref;
            @if (subLinkInternalHref) {
                <a
                    class="flex h-24 w-full flex-1 items-center justify-between rounded-lg bg-surface-A px-8 py-4 text-left shadow"
                    [interactaRouterLink]="subLinkInternalHref"
                    (navigate)="onNavigate($event)"
                >
                    <p
                        class="line-clamp-1 typo-sm wrap-break-word"
                        [matTooltip]="subLinkLabel"
                    >
                        {{ subLinkLabel }}
                    </p>
                </a>
            } @else {
                <a
                    class="flex h-24 w-full flex-1 items-center justify-between rounded-lg bg-surface-A px-8 py-4 text-left shadow"
                    [interactaRouterLink]="subLink | apply: subLinkExternalHref"
                    (navigate)="
                        handleExternalLinkClick($event, subLink);
                        onNavigate($event)
                    "
                >
                    <p
                        class="line-clamp-1 typo-sm wrap-break-word"
                        [matTooltip]="subLinkLabel"
                    >
                        {{ subLinkLabel }}
                    </p>
                </a>
            }
        }
    </div>
} @else {
    <div class="relative">
        @if (internalHref()) {
            <a
                class="flex h-152 w-204 flex-col rounded-2xl rounded-tr-20 bg-surface-A p-8 shadow focus-outside"
                [interactaRouterLink]="internalHref()"
                (navigate)="onNavigate($event)"
            >
                <ng-container *ngTemplateOutlet="cardContent" />
            </a>
        } @else {
            <a
                class="flex h-152 w-204 flex-col rounded-2xl rounded-tr-20 bg-surface-A p-8 shadow focus-outside"
                [interactaRouterLink]="externalHref()"
                (navigate)="handleExternalLinkClick($event); onNavigate($event)"
            >
                <ng-container *ngTemplateOutlet="cardContent" />
            </a>
        }

        @if (isExternalLink()) {
            @let label =
                (pinned()
                    ? 'BUTTON.LABEL_BUTTON_UNPIN'
                    : 'BUTTON.LABEL_BUTTON_PIN'
                ) | translate;
            @let ariaLabel =
                (pinned()
                    ? 'SHARED.ACCESSIBILITY.UNPIN_ITEM'
                    : 'SHARED.ACCESSIBILITY.PIN_ITEM'
                ) | translate: { name: normalizedLink().label };
            <button
                class="absolute top-0 right-0 flex size-40 items-center justify-center rounded-full bg-surface-A"
                type="button"
                [attr.aria-label]="ariaLabel"
                [attr.aria-pressed]="pinned()"
                [matTooltip]="label"
                (click)="togglePin()"
                (mouseenter)="isHovering.set(true)"
                (mouseleave)="isHovering.set(false)"
            >
                <interacta-icon
                    class="size-24 transition-transform duration-300"
                    [class.rotate-0]="!pinned() && isHovering()"
                    [class.rotate-45]="
                        (pinned() && isHovering()) ||
                        (!pinned() && !isHovering())
                    "
                    [icon]="pinned() || isHovering() ? 'pin-filled' : 'pin'"
                />
            </button>
        }
    </div>
}

<ng-template #cardContent>
    @let imageUrl = normalizedLink().imageUrl;
    @if (imageUrl) {
        @if (
            normalizedLink().linkType === 'useful' &&
                (imageUrl | storageTemporaryLink$ | async);
            as resolvedSrc
        ) {
            <interacta-image
                class="link-card__image"
                [alt]="''"
                [classes]="'rounded-lg'"
                [src]="resolvedSrc"
                (loadError)="handleLoadError(resolvedSrc)"
            />
        } @else {
            <interacta-image
                class="link-card__image"
                [alt]="''"
                [classes]="'rounded-lg'"
                [src]="imageUrl"
            />
        }
    } @else {
        <div
            class="aspect-video w-full rounded-lg"
            [style.background]="configBgColor() ?? randBgColor()"
        ></div>
    }

    <div class="absolute bottom-0 left-0 w-full rounded-b-2xl bg-surface-A p-8">
        <span
            class="line-clamp-2 text-left typo-sm"
            [matTooltip]="normalizedLink().label"
        >
            {{ normalizedLink().label }}
        </span>
    </div>
</ng-template>
